export enum AccountJointChangeStatus {
  Loading = 'loading',
  Failed = 'failed',
  Complete = 'complete',
}
